export default __webpack_public_path__ + "static/media/bradley_frew.8747f99b.jpg";